<template>
  <table class="lh1-s lh2 table table--fleet">
    <thead>
      <tr class="size2-m font2 size3-l size1">
        <th>Name</th>
        <th>DWCC</th>
        <th>Hold capacity</th>
        <th>Length over all</th>
        <th>Max. draught</th>
        <th>Gear</th>
        <th>Ice class</th>
      </tr>
    </thead>
    <tbody>
      <tr class="size2-m size1 font1" v-for="ship in fleetlist" :key="ship.id">
        <td data-name="Name">
          <a :href="ship.url" class="lh1 font2 c-brand-1 size4 link-style2 size2-m size3-l sizelink">{{ ship.name }}</a>
        </td>
        <td data-name="DWCC">{{ ship.dwcc }}</td>
        <td data-name="Hold capacity">{{ ship.holdcapacity }}</td>
        <td data-name="Length over all">{{ ship.length }}</td>
        <td data-name="Max. draught">{{ ship.draught }}</td>
        <td data-name="Gear">{{ ship.gear }}</td>
        <td data-name="Ice class">{{ ship.iceclass }}</td>
      </tr>

    </tbody>
  </table>
</template>

<script>
export default {
  name: 'Fleetlist',
  props: {
    fleetlist: Array
  }
}
</script>
